module.exports = __webpack_public_path__ + "img/ft_brewers_grains.5912ffaa.jpg";